import Main from "./components/Main.vue";

export default [
  { path: "/institucional", name: "institucionalMain", component: Main }
];
